import { defineMessages } from 'react-intl';

export const a2aLegalDisclaimerMessages = defineMessages({
  agreementHeader: {
    id: 'oauth.a2a.bestPracticesHeader',
    defaultMessage: "By accepting, you agree to Atlassian's ",
    description: 'Header for the legal disclaimer agreement',
  },
  agreementLinks: {
    id: 'oauth.a2a.bestPracticesLinks',
    defaultMessage: '{privacyPolicyLink} and {termsOfUseLink}',
    description:
      'Legal disclaimer about privacy policy and terms of use',
  },
  privacyPolicy: {
    id: 'oauth.a2a.privacyPolicy',
    defaultMessage: 'privacy policy',
    description: 'Link text for the privacy policy',
  },
  termsOfUse: {
    id: 'oauth.a2a.termsOfUse',
    defaultMessage: 'terms of use',
    description: 'Link text for the terms of use',
  },
});
